import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import {
  EducationTooltip,
  EducationTooltipAnchor,
  EducationTooltipBadge,
  EducationTooltipContent,
  EducationTooltipHeader,
  EducationTooltipImage,
} from '@fiverr-private/education_tooltip';
import { Text } from '@fiverr-private/typography';
import { getContext } from '@fiverr-private/fiverr_context';
import { AppI18n, appTranslate } from '../../../../i18n';
import { EDUCATION_TOOLTIP_STORAGE_KEY, GIF_URL_PREFIX } from './More.constants';

interface MoreOptionsWrapperProps {
  shouldShowEditButton?: boolean;
  shouldShowDuplicateButton?: boolean;
  isFirstRow?: boolean;
}

export const MoreOptionsWrapper = ({
  children,
  shouldShowEditButton,
  shouldShowDuplicateButton,
  isFirstRow = false,
}: React.PropsWithChildren<MoreOptionsWrapperProps>) => {
  const { isMobile } = getContext();
  const shouldShowTooltip = !isMobile;

  if (!shouldShowEditButton || !isFirstRow || !shouldShowTooltip) {
    return <>{children}</>;
  }

  const gifUrl = shouldShowDuplicateButton
    ? `${GIF_URL_PREFIX}-1762349986192/brief_edit_duplicate_education_tooltip.gif`
    : `${GIF_URL_PREFIX}-1762349986209/brief_edit_education_tooltip.gif`;

  const imageAlt = appTranslate('lobby.education_tooltip.image_alt');

  const handleTooltipClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <EducationTooltip variant="white" position="left-start" tooltipStorageKey={EDUCATION_TOOLTIP_STORAGE_KEY}>
      <EducationTooltipAnchor>{children}</EducationTooltipAnchor>
      <Container onClick={handleTooltipClick}>
        <EducationTooltipContent closeOnClickOutside>
          <EducationTooltipImage alt={imageAlt} src={gifUrl} />
          <EducationTooltipHeader>
            <Stack alignItems="center" marginTop="2">
              <Text fontWeight="semibold">
                <AppI18n
                  k={`lobby.education_tooltip.${shouldShowDuplicateButton ? 'title_edit_duplicate' : 'title_edit'}`}
                />
              </Text>
              <EducationTooltipBadge />
            </Stack>
          </EducationTooltipHeader>
          <Text textAlign="start">
            <AppI18n k={`lobby.education_tooltip.${shouldShowDuplicateButton ? 'body_edit_duplicate' : 'body_edit'}`} />
          </Text>
        </EducationTooltipContent>
      </Container>
    </EducationTooltip>
  );
};
